export const pharmacyCaptchaActions = {
  GENERATE_CAPTCHA: {
    REQUEST: 'pharmacy-generate-captcha/generate-captcha-request',
    SUCCESS: 'pharmacy-generate-captcha/generate-captcha-success',
    FAILURE: 'pharmacy-generate-captcha/generate-captcha-failure'
  },

  VERIFY_CAPTCHA: {
    REQUEST: 'pharmacy-verify-captcha/verify-captcha-request',
    SUCCESS: 'pharmacy-verify-captcha/verify-captcha-success',
    FAILURE: 'pharmacy-verify-captcha/verify-captcha-failure'
  }
};
